/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_EquityInputs */

const en_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity / stock options`)
};

const de_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beteiligung / Aktienoptionen`)
};

const fr_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions / stock options`)
};

const es_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participación / opciones sobre acciones`)
};

const it_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity / stock option`)
};

const nl_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity / aandelenopties`)
};

const pl_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udziały / opcje na akcje`)
};

const fi_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osakeoptiot`)
};

const da_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktieoptioner`)
};

const sv_salary_negotiate_other_equity = /** @type {(inputs: Salary_Negotiate_Other_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktieoptioner`)
};

/**
* | output |
* | --- |
* | "Equity / stock options" |
*
* @param {Salary_Negotiate_Other_EquityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_equity = /** @type {((inputs?: Salary_Negotiate_Other_EquityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_EquityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_equity(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_equity(inputs)
	if (locale === "es") return es_salary_negotiate_other_equity(inputs)
	if (locale === "it") return it_salary_negotiate_other_equity(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_equity(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_equity(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_equity(inputs)
	if (locale === "da") return da_salary_negotiate_other_equity(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_equity(inputs)
	return en_salary_negotiate_other_equity(inputs)
});